<template>
  <div>
    <Transition
      enter-active-class="ease-out duration-300"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="ease-in duration-200"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-show="!userDataLoaded"
        class="fixed inset-0 min-h-screen flex items-center justify-center z-99999 bg-white"
      >
        <LoadingSpinner message="Loading..." />
      </div>
    </Transition>
    <StagingBanner v-if="isNonProd" />
    <Sidebar v-model:open="sidebarOpen" :is-non-prod="isNonProd" />
    <div
      class="flex flex-1 flex-col transition-[padding] duration-300 ease-in-out"
      :class="sidebarOpen ? 'pl-64' : 'pl-14'"
    >
      <main class="flex-1">
        <slot />
        <div
          id="admin-main-bottom-portal"
          class="shrink-0"
          aria-hidden="true"
        />
      </main>
    </div>
    <NotificationContainer />
    <SessionExpiryModal
      :extend-session="() => bffClient.getSessionInfo()"
      :expiry-time="sessionExpires"
      :auth-status="auth.status"
      :sign-out="auth.signOut"
    />
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import StagingBanner from '~/components/common/StagingBanner.vue'
import Sidebar from '~/components/navigation/Sidebar.vue'
import LoadingSpinner from '~~/components/common/LoadingSpinner.vue'
import NotificationContainer from '~~/components/notifications/NotificationContainer.vue'
import { useUserSessionStore } from '~/store/user-session'
import SessionExpiryModal from '~/../member-webapp-shared/components/SessionExpiryModal.vue'

useHead({
  htmlAttrs: {
    class: 'h-full bg-fp-gray-1',
  },
  bodyAttrs: {
    class: 'h-full',
  },
  titleTemplate: (titleChunk) =>
    titleChunk ? `${titleChunk} · FP Navigator` : 'FP Navigator',
})

const auth = useAuth()
const bffClient = useBffClient()

const isNonProd = useRuntimeConfig().public.environment !== 'prod'

const { userDataLoaded, sessionExpires } = storeToRefs(useUserSessionStore())

const sidebarOpen = ref(true)

onMounted(() => {
  // Default to expanded sidebar on desktop
  if (window.matchMedia('(max-width: 768px)').matches) {
    sidebarOpen.value = false
  }
})
</script>
